import { Option } from "../../util/option";
import { GetDataKind } from "../../services/data-kinds";

import { DisplayColumn, ErrorMessage } from "../../util/spreadsheet-data-utils";

export type DataKindMaintenancePageState = {
  isSaved: boolean;
  searchResult: {
    dataKindList: DataKind[];
  };
  spreadsheetSelectedRowIndex: number | undefined;
  dataList: DataList;
  displayColumn: DisplayColumn[];
};

export type SpreadsheetState = { dataKindList: DataKind[]; dataList: DataList };

export type DataKind = {
  /**
   * Add Flag
   */
  addFlg: string;

  /**
   * Edited Flag
   */
  isEdited: boolean;

  displayDeployCheckbox: boolean;

  /**
   * Deploy datakind name flag
   */
  deployFlg: boolean;

  /**
   * get-data-kind response
   */
  getDataKind: GetDataKind;

  /**
   * for error
   */
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};
export type DataList = {
  inDefCommonFlagType: Option[];
};
export type PageNewState =
  | DataKindMaintenancePageState
  | ((prevState: DataKindMaintenancePageState) => DataKindMaintenancePageState);
